var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SfButton',{staticClass:"product-card-actions__add-to-cart",attrs:{"disabled":_vm.isLoading || !_vm.canAddToCart(_vm.product, 1)},on:{"click":_vm.addToCart}},[_vm._v("\n  "+_vm._s(_vm.$t('Buy'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }